import { Overrides } from '@material-ui/core/styles/overrides';

export const MuiGDButton: Overrides['MuiGDButton'] = {
  root: {
    height: 40,
    borderRadius: 20,
  },
};
